"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc1820ImplementerFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var Erc1820ImplementerFactory = /** @class */ (function (_super) {
    __extends(Erc1820ImplementerFactory, _super);
    function Erc1820ImplementerFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    Erc1820ImplementerFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    Erc1820ImplementerFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    Erc1820ImplementerFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    Erc1820ImplementerFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    Erc1820ImplementerFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return Erc1820ImplementerFactory;
}(contracts_1.ContractFactory));
exports.Erc1820ImplementerFactory = Erc1820ImplementerFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'interfaceHash',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'canImplementInterfaceForAddress',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '0x608060405234801561001057600080fd5b50610134806100206000396000f3fe6080604052348015600f57600080fd5b506004361060285760003560e01c8063249cb3fa14602d575b600080fd5b606360048036036040811015604157600080fd5b508035906020013573ffffffffffffffffffffffffffffffffffffffff166075565b60408051918252519081900360200190f35b60008281526020818152604080832073ffffffffffffffffffffffffffffffffffffffff8516845290915281205460ff1660af57600060f7565b60405160200180807f455243313832305f4143434550545f4d414749430000000000000000000000008152506014019050604051602081830303815290604052805190602001205b939250505056fea264697066735822122066552970f8940e3c30a7a45f9b1646cb3958767e90855b1b47e24b06f8164ce664736f6c63430007040033';
//# sourceMappingURL=Erc1820ImplementerFactory.js.map